module.exports = __webpack_public_path__ + "img/file-icon_doc.15b86e78.svg";